// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import dealIconBackground from 'assets/img/deal.svg';
// page images
import networkingIconBackground from 'assets/img/networking.svg';
// page styles
import sponsorStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/sponsorStyle.jsx';
// core components
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
// gatsby libraries
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

const useStyles = makeStyles(sponsorStyle);

export default function SectionFeatures() {
  const {
    albrechtFuneralHomesLogo,
    anytimeFitnessLogo,
    ascendiumLogo,
    avondaleRoofingLogo,
    buschLightLogo,
    cmPrintingLogo,
    conklinEnterpriseLogo,
    diazRoofingLogo,
    edgertonReporterLogo,
    eldonHomesLogo,
    elevateEstatesRealtyLogo,
    fabickCaterpillarLogo,
    frontierVerizonLogo,
    gflLogo,
    hausmannGroupLogo,
    homeBackupSystemsLogo,
    jBeckerConstructionLogo,
    lakeEffectVodkaLogo,
    lonsJonsLogo,
    minutemanPressLogo,
    mkApparelLogo,
    morrisonsAutoSalvageLogo,
    reitzDentalLogo,
    roetheLawLogo,
    schultzHausLogo,
    theHogLogo,
    theScharineGroupLogo,
    twoBrothersLogo,
    wisconsinGreenhouseLogo,
  } = useStaticQuery(graphql`
    query getSponsorLogos {
      albrechtFuneralHomesLogo: file(
        relativePath: { eq: "logos/albrecht-funeral-homes-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      anytimeFitnessLogo: file(
        relativePath: { eq: "logos/anytime-fitness-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      ascendiumLogo: file(relativePath: { eq: "logos/ascendium-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      avondaleRoofingLogo: file(
        relativePath: { eq: "logos/avondale-roofing-logo.webp" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      buschLightLogo: file(relativePath: { eq: "logos/busch-light-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      cmPrintingLogo: file(relativePath: { eq: "logos/c&m-logo.jpeg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      conklinEnterpriseLogo: file(
        relativePath: { eq: "logos/conklin-enterprise-logo.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      diazRoofingLogo: file(
        relativePath: { eq: "logos/diaz-roofing-company-logo.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      edgertonReporterLogo: file(
        relativePath: { eq: "logos/edgerton-reporter-logo.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      eldonHomesLogo: file(relativePath: { eq: "logos/eldon-homes-logo.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      elevateEstatesRealtyLogo: file(
        relativePath: { eq: "logos/elevate-estates-realty-logo.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      fabickCaterpillarLogo: file(
        relativePath: { eq: "logos/fabick-cat-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      frontierVerizonLogo: file(
        relativePath: { eq: "logos/frontier-verizon-logo.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      gflLogo: file(relativePath: { eq: "logos/gfl-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      hausmannGroupLogo: file(
        relativePath: { eq: "logos/hausmann-group-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      homeBackupSystemsLogo: file(
        relativePath: { eq: "logos/home-backup-systems-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      jBeckerConstructionLogo: file(
        relativePath: { eq: "logos/j-becker-construction-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      lakeEffectVodkaLogo: file(
        relativePath: { eq: "logos/lake-effect-vodka-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      lonsJonsLogo: file(relativePath: { eq: "logos/lons-jons-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      minutemanPressLogo: file(
        relativePath: { eq: "logos/minuteman-press-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      mkApparelLogo: file(
        relativePath: { eq: "logos/mk-apparel-sponsor-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      morrisonsAutoSalvageLogo: file(
        relativePath: { eq: "logos/morrisons-auto-salvage-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      reitzDentalLogo: file(
        relativePath: { eq: "logos/reitz-dental-chilimania.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      roetheLawLogo: file(relativePath: { eq: "logos/roethe-law-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      schultzHausLogo: file(
        relativePath: { eq: "logos/schultz-haus-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      theHogLogo: file(relativePath: { eq: "logos/1059-the-hog-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      theScharineGroupLogo: file(
        relativePath: { eq: "logos/the-scharine-group-logo.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      twoBrothersLogo: file(relativePath: { eq: "logos/2brothers-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
      wisconsinGreenhouseLogo: file(
        relativePath: {
          eq: "logos/wisconsin-greenhouse-company-logo-black.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
    }
  `);
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <img
          className={classes.networkingLogo}
          src={networkingIconBackground}
          alt="Networking Icon"
        />
        <GridContainer
          justifyContent="center"
          alignItems="center"
          className={classes.sponsorsTitleContainer}
        >
          <GridItem xs={12} sm={12} md={12}>
            <h2 className={classes.title}>
              Thank You to our Presenting Sponsors
            </h2>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} className={classes.sponsorsTitleItem}>
            <h3 className={classes.reaperSponsorTitle}>Friday VIP Sponsor</h3>
            <a
              className={classes.gridLogoLink}
              href="https://www.homebackupsystem.net/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={homeBackupSystemsLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Home Backup Systems Logo"
                title="Home Backup Systems"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={6} md={6} className={classes.sponsorsTitleItem}>
            <h3 className={classes.reaperSponsorTitle}>Saturday VIP Sponsor</h3>
            <a
              className={classes.gridLogoLink}
              href="https://www.morrisonsautosalvage.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={morrisonsAutoSalvageLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Morrison's Auto Salvage, Inc Logo"
                title="Morrison's Auto Salvage, Inc"
              />
            </a>
          </GridItem>
        </GridContainer>
        <GridContainer
          className={classes.sponsorsGridContainer}
          alignItems="center"
          justifyContent="center"
        >
          <GridItem xs={12} sm={12} md={12}>
            <h3 className={classes.reaperSponsorTitle}>
              Carolina Reaper Sponsors
            </h3>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://2brothersbarandgrill.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={twoBrothersLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="2Brothers Bar &amp; Grill Logo"
                title="2Brothers Bar &amp; Grill"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.ascendiumeducation.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={ascendiumLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Ascendium Education Group Logo"
                title="Ascendium Education Group"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="http://www.wisconsindistributors.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={buschLightLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Wisconsin Distributors Busch Light Logo"
                title="Wisconsin Distributors"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://edgertonreporter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={edgertonReporterLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Edgerton Reporter Logo"
                title="Edgerton Reporter"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.fabickcat.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={fabickCaterpillarLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Fabick Caterpillar Logo"
                title="Fabick Caterpillar"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.frontier.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={frontierVerizonLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Frontier Verizon Logo"
                title="Frontier Verizon"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://gflenv.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={gflLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="GFL Green for Life Logo"
                title="GFL Green for Life"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.homebackupsystem.net/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={homeBackupSystemsLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Home Backup Systems Logo"
                title="Home Backup Systems"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://lonsjons.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={lonsJonsLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Lon's Jon's Logo"
                title="Lon's Jon's LLC"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://minuteman.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={minutemanPressLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Minuteman Press Logo"
                title="Minuteman Press"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://wearmk.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={mkApparelLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="MK Apparel Logo"
                title="MK Apparel"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.morrisonsauto.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={morrisonsAutoSalvageLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Morrison's Auto Salvage, Inc Logo"
                title="Morrison's Auto Salvage, Inc"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.1059thehog.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={theHogLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="105.9 The Hog Logo"
                title="105.9 The Hog"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.edgertondentist.com/about-us/dr-thomas-reitz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={reitzDentalLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Reitz and Gregerson Dental Logo"
                title="Reitz and Gregerson Dental"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.roethelaw.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: '#000054', padding: '3px 0' }}
            >
              <GatsbyImage
                image={roetheLawLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Roethe Law Logo"
                title="Roethe Law"
              />
            </a>
          </GridItem>
        </GridContainer>
        <img
          className={classes.dealLogo}
          src={dealIconBackground}
          alt="Deal Icon"
        />
        <GridContainer
          className={classes.sponsorsGridContainer}
          alignItems="center"
          justifyContent="center"
        >
          <GridItem xs={12} sm={12} md={12}>
            <h3 className={classes.ghostSponsorTitle}>Ghost Pepper Sponsors</h3>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.albrechtfuneralhomes.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={albrechtFuneralHomesLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Albrecht Funeral Home Logo"
                title="Albrecht Funeral Home"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://avondaleroofing.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={avondaleRoofingLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Avondale Roofing Logo"
                title="Avondale Roofing"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="http://www.cmprinting.biz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={cmPrintingLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="C&M Printing Logo"
                title="C&M Printing"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.eldonhomes.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={eldonHomesLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Eldon Homes Logo"
                title="Eldon Homes"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.elevateestatesrealty.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={elevateEstatesRealtyLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Elevate Estates Realty Logo"
                title="Elevate Estates Realty"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <b>Jessica Osborne</b>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <b>Justin Miller</b>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.lakeeffectvodka.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={lakeEffectVodkaLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Lake Effect Vodka Logo"
                title="Lake Effect Vodka"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.schultzhaussocialmedia.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={schultzHausLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Schultz Haus Social Media Logo"
                title="Schultz Haus Social Media"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.wisconsingreenhousecompany.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={wisconsinGreenhouseLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Wisconsin Greenhouse Company Logo"
                title="Wisconsin Greenhouse Company"
              />
            </a>
          </GridItem>
        </GridContainer>
        <GridContainer
          className={classes.sponsorsGridContainer}
          alignItems="center"
          justifyContent="center"
        >
          <GridItem xs={12} sm={12} md={12}>
            <h3 className={classes.ghostSponsorTitle}>Habanero Sponsors</h3>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.facebook.com/AnytimeFitnessEdgertonWI/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={anytimeFitnessLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Anytime Fitness Logo"
                title="Anytime Fitness"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            {/* <a
              className={classes.gridLogoLink}
              href="https://www.carriersource.io/carriers/conklin-enterprise-llc"
              target="_blank"
              rel="noopener noreferrer"
            > */}
            <GatsbyImage
              image={conklinEnterpriseLogo.childImageSharp.gatsbyImageData}
              className={classes.gridLogo}
              imgStyle={{ objectFit: 'contain' }}
              alt="Conklin Enterprise Logo"
              title="Conklin Enterprise"
            />
            {/* </a> */}
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://diazroofingedgerton.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={diazRoofingLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Diaz Roofing Logo"
                title="Diaz Roofing"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.myhaus.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={hausmannGroupLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="Hausmann Group Logo"
                title="Hausmann Group"
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.jbeckerconstructioninc.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={jBeckerConstructionLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="J. Becker Construction, Inc. Logo"
                title="J. Becker Construction, Inc."
              />
            </a>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <b>Jacki &amp; Don Fairbairn</b>
          </GridItem>
          <GridItem xs={12} sm={3} className={classes.sponsorsGridItem}>
            <a
              className={classes.gridLogoLink}
              href="https://www.thescharinegroup.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GatsbyImage
                image={theScharineGroupLogo.childImageSharp.gatsbyImageData}
                className={classes.gridLogo}
                imgStyle={{ objectFit: 'contain' }}
                alt="The Scharine Group Logo"
                title="The Scharine Group"
              />
            </a>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} md={12} className={classes.sponsorButton}>
            <Link to="/sponsors">
              <Button color="primary" size="lg">
                See All Sponsors
              </Button>
            </Link>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
